import { SVGAttributes } from 'react';

export function GlobalSettingIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      fill="currentColor"
      height="24px"
      width="24px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 494.172 494.172"
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <path
          d="M116.203,315.742c3.492-2.414,7.336-4.336,11.552-5.454c3.185-0.852,6.468-1.287,9.767-1.287
     c1.558,0,3.07,0.458,4.633,0.652c-1.458-3.145-2.882-6.379-4.216-9.782c4.375,0.742,8.958,1.208,13.482,1.772
     C157.789,289.988,170.056,282,184.236,282h31.091c9.598,0,18.283,3.7,24.93,9.645c0.084-5.725,1.389-11.455,3.988-16.891
     c-10.898,1.553-22.078,2.75-33.72,3.194v-66.734h63.352c-0.243,6.225-0.992,11.951-1.553,17.871
     c4.906-4.73,10.843-8.308,17.613-10.136c3.22-0.861,6.548-1.237,9.876-1.295c0.129-2.17,0.412-4.246,0.491-6.44h20.648
     c4.52-13.12,15.427-23.199,29.077-26.447h-49.725c-0.69-18.217-2.718-35.622-5.893-51.958
     c30.247,10.319,53.471,25.093,64.665,42.211c0.368,2.797,0.625,5.67,0.819,8.533h33.124C386.358,81.25,301.232,0,197.307,0
     C89.051,0,0.946,88.095,0.946,196.391c0,67.594,34.336,127.305,86.463,162.656c0.61-1.474,1.216-2.951,2.029-4.367l14.284-24.742
     c-21.948-15.458-39.959-36.09-52.15-60.235c15.813,9.58,34.721,17.565,56.174,23.446
     C110.246,301.127,113.123,308.584,116.203,315.742z M345.259,127.62c-16.229-10.198-35.971-18.596-58.352-24.781
     c-7.178-22.819-16.795-42.451-28.402-57.806C296.838,60.613,327.839,90.282,345.259,127.62z M210.525,38.195
     c17.4,6.981,34.176,27.477,46.154,57.928c-14.648-2.453-30.148-3.934-46.154-4.489V38.195z M210.525,118.032
     c19.459,0.781,38.045,3.152,55.241,6.87c4.385,17.879,7.262,37.939,8.11,59.864h-63.352V118.032z M184.088,277.948
     c-19.404-0.741-38.045-3.123-55.236-6.846c-4.37-17.871-7.232-37.965-8.07-59.889h63.307V277.948z M184.088,184.767h-63.307
     c0.838-21.925,3.7-41.985,8.07-59.864c17.191-3.718,35.832-6.089,55.236-6.87V184.767z M184.088,38.195v53.438
     c-16.007,0.556-31.502,2.036-46.15,4.489C149.932,65.672,166.692,45.177,184.088,38.195z M136.113,45.033
     c-11.607,15.354-21.229,34.986-28.367,57.806c-22.42,6.186-42.156,14.583-58.387,24.781
     C66.779,90.282,97.775,60.613,136.113,45.033z M36.185,221.982c-0.59-3.579-1.121-7.11-1.469-10.769h59.627
     c0.675,18.208,2.688,35.646,5.862,51.989C70.505,253.117,47.589,238.648,36.185,221.982z M94.344,184.767H34.573
     c0.203-3.274,0.551-6.548,0.968-9.747c11.194-17.118,34.413-31.934,64.665-42.211C97.031,149.145,95.018,166.55,94.344,184.767z"
        />
        <path
          d="M485.16,346.393l-14.796-8.549c0.495-3.811,1.171-7.544,1.171-11.502c0-3.924-0.676-7.696-1.171-11.508l14.796-8.534
     c3.716-2.147,6.403-5.664,7.5-9.788c1.126-4.135,0.53-8.534-1.593-12.252l-19.597-33.908c-2.977-5.173-8.394-8.077-13.978-8.077
     c-2.733,0-5.501,0.702-8.04,2.172l-14.722,8.487c-6.161-4.707-12.758-8.895-20.01-11.93v-16.608
     c0-8.911-7.242-16.136-16.136-16.136H359.43c-8.908,0-16.136,7.225-16.136,16.136v16.608c-7.271,3.034-13.849,7.223-20.023,11.93
     l-14.707-8.494c-2.461-1.441-5.258-2.165-8.056-2.165c-1.398,0-2.817,0.179-4.186,0.548c-4.132,1.111-7.639,3.805-9.776,7.52
     l-19.612,33.918c-4.44,7.723-1.815,17.576,5.923,22.04l14.781,8.534c-0.174,1.326-0.353,2.646-0.531,3.973
     c2.882,2.598,5.496,5.494,7.465,8.935l15.605,26.994c4.984,8.686,6.304,18.779,3.68,28.553
     c-1.815,6.609-5.307,12.475-10.148,17.141c2.252,2.162,4.137,4.654,5.773,7.301l13.79-7.961
     c6.175,4.705,12.737,8.879,20.023,11.934v16.619c0,8.897,7.228,16.111,16.136,16.111h39.155c8.894,0,16.136-7.215,16.136-16.111
     v-16.619c7.287-3.055,13.849-7.228,20.01-11.934l14.722,8.492c2.475,1.424,5.272,2.165,8.075,2.165
     c1.398,0,2.782-0.187,4.147-0.548c4.137-1.109,7.673-3.813,9.797-7.527l19.597-33.918
     C495.507,360.718,492.884,350.85,485.16,346.393z M379.008,384.864c-32.261,0-58.506-26.252-58.506-58.522
     c0-32.262,26.245-58.505,58.506-58.505c32.261,0,58.505,26.243,58.505,58.505C437.513,358.612,411.268,384.864,379.008,384.864z"
        />
        <path
          d="M379.008,284.31c-23.179,0-42.032,18.853-42.032,42.032c0,23.189,18.854,42.05,42.032,42.05
     c23.179,0,42.032-18.861,42.032-42.05C421.04,303.162,402.186,284.31,379.008,284.31z"
        />
        <path
          d="M284.064,416.353l-11.755-6.78c0.367-3.032,0.912-5.999,0.912-9.129c0-3.128-0.545-6.114-0.912-9.145l11.755-6.772
     c2.927-1.707,5.069-4.496,5.968-7.777c0.888-3.299,0.407-6.773-1.284-9.717l-15.571-26.92c-2.351-4.111-6.66-6.403-11.085-6.403
     c-2.173,0-4.36,0.548-6.369,1.714l-11.696,6.748c-4.905-3.74-10.134-7.064-15.877-9.484v-13.174
     c0-7.078-5.744-12.805-12.822-12.805h-31.091c-7.078,0-12.792,5.727-12.792,12.805v13.174c-5.744,2.421-10.987,5.744-15.878,9.484
     l-11.691-6.766c-1.948-1.126-4.137-1.696-6.354-1.696c-1.125,0-2.252,0.143-3.363,0.441c-3.269,0.87-6.066,3.001-7.771,5.944
     l-15.556,26.938c-3.507,6.13-1.429,13.962,4.697,17.494l11.746,6.772c-0.372,3.03-0.903,6.017-0.903,9.145
     c0,3.13,0.531,6.097,0.903,9.122l-11.746,6.772c-6.126,3.529-8.204,11.371-4.697,17.492l15.556,26.946
     c1.706,2.919,4.503,5.066,7.771,5.959c1.092,0.291,2.203,0.435,3.313,0.435c2.237,0,4.439-0.589,6.403-1.728l11.662-6.733
     c4.92,3.747,10.163,7.063,15.907,9.467v13.198c0,7.064,5.714,12.798,12.792,12.798h31.091c7.078,0,12.822-5.734,12.822-12.798
     v-13.198c5.758-2.404,10.972-5.72,15.877-9.467l11.696,6.733c1.964,1.14,4.167,1.728,6.403,1.728c1.092,0,2.202-0.143,3.279-0.435
     c3.283-0.892,6.096-3.04,7.772-5.959l15.571-26.946C292.284,427.728,290.181,419.885,284.064,416.353z M199.772,435.738
     c-19.479,0-35.277-15.806-35.277-35.294c0-19.504,15.798-35.31,35.277-35.31c19.527,0,35.326,15.806,35.326,35.31
     C235.099,419.933,219.3,435.738,199.772,435.738z"
        />
      </g>
    </svg>
  );
}
